// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      of_client_slug: string,
      of_pipeline_slug: string,
      of_usecase_slug: string,
    })
  ),
});
